import styled from 'styled-components'

export const Wrapper = styled.div`
  padding-top: 0.4rem;
`
